import { Col, Row, Space } from "antd";
import BackOffice from "./content/backoffice";
import ListMenus from "./content/list-menus";
import styled from "styled-components";
import tw from "twin.macro";
import Summary from "./content/summary";
import SmoothUpApp from "./content/app-smooth-up";
import TeamUpApp from "./content/app-team-up";

export const SpaceStyle = styled(Space)`
  ${tw`h-[200px]`}
  .count {
    font-size: 24px;
    color: #44955b;
  }
  .people {
    font-size: 18px;
    color: #276347;
  }
  .title {
    color: #58595b;
  }
`;

const Statistics = () => {
  return (
    <div>
      <Row gutter={[14, 14]}>
        <Col md={24} lg={12} xl={12} xxl={6}>
          <BackOffice />
        </Col>
        <Col md={24} lg={12} xl={12} xxl={6}>
          <TeamUpApp />
        </Col>
        <Col md={24} lg={12} xl={12} xxl={6}>
          <SmoothUpApp />
        </Col>
        <Col md={24} lg={12} xl={12} xxl={6}>
          <Summary />
        </Col>
        <Col span={24}>
          <ListMenus />
        </Col>
      </Row>
    </div>
  );
};

export default Statistics;
